/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getHelpPage } from '../fn/user-help-api/get-help-page';
import { GetHelpPage$Params } from '../fn/user-help-api/get-help-page';
import { getHelpPagebyRoute } from '../fn/user-help-api/get-help-pageby-route';
import { GetHelpPagebyRoute$Params } from '../fn/user-help-api/get-help-pageby-route';
import { getHelpPageNext } from '../fn/user-help-api/get-help-page-next';
import { GetHelpPageNext$Params } from '../fn/user-help-api/get-help-page-next';
import { getHelpPagePrevious } from '../fn/user-help-api/get-help-page-previous';
import { GetHelpPagePrevious$Params } from '../fn/user-help-api/get-help-page-previous';
import { getHelpPages } from '../fn/user-help-api/get-help-pages';
import { GetHelpPages$Params } from '../fn/user-help-api/get-help-pages';
import { getHelpPageTagCloud } from '../fn/user-help-api/get-help-page-tag-cloud';
import { GetHelpPageTagCloud$Params } from '../fn/user-help-api/get-help-page-tag-cloud';
import { HelpPageUserDto } from '../models/help-page-user-dto';
import { PageDtoHelpPageHelpPageUserDto } from '../models/page-dto-help-page-help-page-user-dto';
import { SimpleList } from '../models/simple-list';

@Injectable({ providedIn: 'root' })
export class UserHelpApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getHelpPageTagCloud()` */
  static readonly GetHelpPageTagCloudPath = '/api/user/help/tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpPageTagCloud()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPageTagCloud$Response(params?: GetHelpPageTagCloud$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleList>> {
    return getHelpPageTagCloud(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHelpPageTagCloud$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPageTagCloud(params?: GetHelpPageTagCloud$Params, context?: HttpContext): Observable<SimpleList> {
    return this.getHelpPageTagCloud$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleList>): SimpleList => r.body)
    );
  }

  /** Path part for operation `getHelpPages()` */
  static readonly GetHelpPagesPath = '/api/user/help/pages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpPages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPages$Response(params: GetHelpPages$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoHelpPageHelpPageUserDto>> {
    return getHelpPages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHelpPages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPages(params: GetHelpPages$Params, context?: HttpContext): Observable<PageDtoHelpPageHelpPageUserDto> {
    return this.getHelpPages$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoHelpPageHelpPageUserDto>): PageDtoHelpPageHelpPageUserDto => r.body)
    );
  }

  /** Path part for operation `getHelpPage()` */
  static readonly GetHelpPagePath = '/api/user/help/pages/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpPage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPage$Response(params: GetHelpPage$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpPageUserDto>> {
    return getHelpPage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHelpPage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPage(params: GetHelpPage$Params, context?: HttpContext): Observable<HelpPageUserDto> {
    return this.getHelpPage$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpPageUserDto>): HelpPageUserDto => r.body)
    );
  }

  /** Path part for operation `getHelpPagePrevious()` */
  static readonly GetHelpPagePreviousPath = '/api/user/help/pages/{id}/previous';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpPagePrevious()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPagePrevious$Response(params: GetHelpPagePrevious$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpPageUserDto>> {
    return getHelpPagePrevious(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHelpPagePrevious$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPagePrevious(params: GetHelpPagePrevious$Params, context?: HttpContext): Observable<HelpPageUserDto> {
    return this.getHelpPagePrevious$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpPageUserDto>): HelpPageUserDto => r.body)
    );
  }

  /** Path part for operation `getHelpPageNext()` */
  static readonly GetHelpPageNextPath = '/api/user/help/pages/{id}/next';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpPageNext()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPageNext$Response(params: GetHelpPageNext$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpPageUserDto>> {
    return getHelpPageNext(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHelpPageNext$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPageNext(params: GetHelpPageNext$Params, context?: HttpContext): Observable<HelpPageUserDto> {
    return this.getHelpPageNext$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpPageUserDto>): HelpPageUserDto => r.body)
    );
  }

  /** Path part for operation `getHelpPagebyRoute()` */
  static readonly GetHelpPagebyRoutePath = '/api/user/help/pages/route';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpPagebyRoute()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPagebyRoute$Response(params: GetHelpPagebyRoute$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpPageUserDto>> {
    return getHelpPagebyRoute(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHelpPagebyRoute$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPagebyRoute(params: GetHelpPagebyRoute$Params, context?: HttpContext): Observable<HelpPageUserDto> {
    return this.getHelpPagebyRoute$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpPageUserDto>): HelpPageUserDto => r.body)
    );
  }

}
